module.exports = __webpack_public_path__ + "static/media/video.49022f07.mp4";